import { type ComponentProps } from 'react'
import { twMerge } from 'tailwind-merge'

interface SidepanelSectionSubtitleProps extends ComponentProps<'div'> {}

export function SidepanelSectionSubtitle({ className, children, ...props }: SidepanelSectionSubtitleProps) {
  return (
    <div className={twMerge('ml-auto', className)} {...props}>
      {children}
    </div>
  )
}
